module.exports = __webpack_public_path__ + "static/img/ilu-pague.b0cb0d0.jpg";